import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AppRouter from './AppRouter';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const location = useLocation();

  useEffect(() => {
    Aos.init({
      duration: 800,
      offset: 100,
    });
    Aos.refresh();
  }, [location.pathname]);

  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <main>
        <AppRouter />
      </main>
      <Footer />
    </div>
  );
}

export default App;
